export enum PromptDefaultFolder {
  ID = '__default_private__',
  NAME = 'Private',
}

export enum PromptVisibility {
  ONLY_YOU = 'only_you', // legacy value, enforced as private
  PRIVATE = 'private',
  PUBLIC = 'public',
}
